module.exports = __webpack_public_path__ + "static/media/thumb-up-pink.766d6b91.svg";